import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a3254ed8&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3254ed8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\english\\new-evaluation\\src\\admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a3254ed8')) {
      api.createRecord('a3254ed8', component.options)
    } else {
      api.reload('a3254ed8', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=a3254ed8&scoped=true&", function () {
      api.rerender('a3254ed8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/orderinfo/index.vue"
export default component.exports